module.exports = __webpack_public_path__ + "img/179973.553c773f.png";